module.exports = __webpack_public_path__ + "static/media/event9.cc01925d.jpg";